import { Outlet } from 'react-router-dom'
import { SiteHeader } from '@/components/SiteHeader'
import { SiteFooter } from '@/components/SiteFooter'

export default function MainLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-1 pt-[4.5rem]">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
